import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, withKeys as _withKeys, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { computed, ref, watch } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'ModalNombreCircuito',
  props: {
    modelValue: { type: Boolean },
    titulo: {},
    textoBoton: {},
    nombreInicial: {},
    guardando: { type: Boolean },
    error: {}
  },
  emits: ["update:modelValue", "guardar"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const show = computed({
  get: () => props.modelValue,
  set: (valor: boolean) => emit("update:modelValue", valor),
});

const nombre = ref("");
// Cada vez que se abre, con el nombre que tiene o vacío
watch(
  () => props.modelValue,
  abierto => {
    if (abierto) nombre.value = props.nombreInicial ?? "";
  },
  { immediate: true }
);

const guardar = () => {
  const limpio = nombre.value.trim();
  if (limpio.length >= 3 && !props.guardando) emit("guardar", limpio);
};

return (_ctx: any,_cache: any) => {
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createBlock(_component_v_dialog, {
    modelValue: show.value,
    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((show).value = $event)),
    "max-width": "420"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_card, null, {
        default: _withCtx(() => [
          _createVNode(_component_v_card_title, { class: "text-wrap" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.titulo), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_v_card_text, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_text_field, {
                modelValue: nombre.value,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((nombre).value = $event)),
                label: "Nombre del circuito",
                placeholder: "Ej: Liga de Murcia 2027",
                variant: "outlined",
                counter: "100",
                maxlength: "100",
                autofocus: "",
                "error-messages": _ctx.error ?? undefined,
                onKeyup: _withKeys(guardar, ["enter"])
              }, null, 8, ["modelValue", "error-messages"])
            ]),
            _: 1
          }),
          _createVNode(_component_v_card_actions, { class: "d-flex flex-wrap ga-2" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_spacer),
              _createVNode(_component_v_btn, {
                color: "grey",
                variant: "text",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (show.value = false))
              }, {
                default: _withCtx(() => [
                  _createTextVNode("Cancelar")
                ]),
                _: 1
              }),
              _createVNode(_component_v_btn, {
                color: "primary",
                variant: "tonal",
                loading: _ctx.guardando,
                disabled: nombre.value.trim().length < 3,
                onClick: guardar
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.textoBoton), 1)
                ]),
                _: 1
              }, 8, ["loading", "disabled"])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})